module.exports = __webpack_public_path__ + "img/capebrolga_92921.ac2e8ead.jpg";